/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ScatterChart = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "7.5", cy: "7.5", r: ".5" }],
    ["circle", { cx: "18.5", cy: "5.5", r: ".5" }],
    ["circle", { cx: "11.5", cy: "11.5", r: ".5" }],
    ["circle", { cx: "7.5", cy: "16.5", r: ".5" }],
    ["circle", { cx: "17.5", cy: "14.5", r: ".5" }],
    ["path", { d: "M3 3v18h18" }]
  ]
];

export { ScatterChart as default };
//# sourceMappingURL=scatter-chart.js.map
